export const hasApensado = (data, next, complete) => {
  return Boolean(data?.apensado || next?.apensado || complete?.apensado);
};

export const isParentApensadoProcess = (data, next, complete) => {
  const isParent = (item) => item?.apensado === true && !item?.apensado_id;

  return Boolean(isParent(data) || isParent(next) || isParent(complete));
};

export const isEssentialPlanProcess = (data, next, complete) => {
  return [data, next, complete].some(
    (item) => item?.sale?.family_plan === "ESSENTIAL"
  );
};
